﻿import { GetCompanyId } from './company.js';

import bootbox from 'bootbox';
import { messageDialog, loadingDialog } from '../common/dialogs';

// ### General Corporate Model ###

// Add Entity, if check is ok .... ### General Corporate Model ###
export function AddEntity() {
    // Eivinds original which were on jquery click event
    //e.preventDefault();
    //e.stopImmediatePropagation();
    
    var CorporateAccessViewType =  parseInt($("#Index_CorporateAccessViewType").val());
    var DialogHeader ="Add new";
    if(CorporateAccessViewType==1){
        DialogHeader="Add new product"
    }

    var dialog = bootbox.dialog({
        //title: "Add entity",
        title : DialogHeader,

        message: "<input type='text' class='form-control input-sm' placeholder='name' />",
        buttons: {
            Add: {
                label: "Add",
                className: "btn-primary",
                callback: function () {
                    newEntity($(dialog).find("input").val());
                }
            },
            Cancel: {
                label: "Cancel",
                className: "btn-default",
                callback: function () {
                }
            }
        }




    });

}


function newEntity(name) {

    //alert("newEntity")


    //var CurrentTab = (state.currenttab != null && state.currenttab == "") ? "Statements" : state.currenttab;
    var CurrentTabnewEntity = "Statements";      // Default assume the general Corporate Model
    var CorporateAccessViewTypenewEntity =  parseInt($("#Index_CorporateAccessViewType").val());
    //if(CorporateAccessViewTypenewEntity == 1){
    //    CurrentTabnewEntity == "CommodityForecast";
    //}
    // Unfortunately it does not work to use the 'CurrentTabnewEntity' in the URL...but fixed by creating alternative ajax call...:)
   
    var CurrentTab = $("#CurrentTab").val();        // This works :)
    //alert(CurrentTab);


    loadingDialog("#corporate-tab-overlay", 1000, 1000, 1, null, "Adding ...", null, null, null, function (callback) {
        
        //if(CorporateAccessViewTypenewEntity == 1){
        //    //CurrentTabnewEntity == "CommodityForecast";
        //    CurrentTabnewEntity == "Setup";                         // Does not work ot use 'CurrentTabnewEntity' in the url below...why not? 
        //    //if(CurrentTab == "CommodityForecast"){
        //    //    CurrentTabnewEntity == "CommodityForecast";
        //    //}            
        //}
        
        if(CorporateAccessViewTypenewEntity == 1){

            // Do not have to use the 'CorporateAccessViewTypenewEntity' could instead use the above/below logic using the 'CurrentTab'

            $.ajax({
                url: Router.action("Portfolio", "CreateEntity", { area: "Corp" }),
                method: "POST",
                data: { name: name, CompanyId: GetCompanyId(), EntityId: GetEntityId() },
                success: function () {                

                    if(CurrentTab == "CommodityForecast"){
                        $.ajax({
                            // url: Router.action("Tab", CurrentTabnewEntity, { area: "Corp" }),       // Does not work to use: CurrentTabnewEntity
                            url: Router.action("Tab", "CommodityForecast", { area: "Corp" }),
                            data: { CompanyId: GetCompanyId(), EntityId: GetEntityId() },
                            method: "GET",
                            statusCode: {
                                200: function (data) {
                                    $("#corp-input-area").html(data);
                                }
                            }
                        });
                    }
                    else{
                        $.ajax({
                            // url: Router.action("Tab", CurrentTabnewEntity, { area: "Corp" }),       // Does not work to use: CurrentTabnewEntity
                            url: Router.action("Tab", "Setup", { area: "Corp" }),
                            data: { CompanyId: GetCompanyId(), EntityId: GetEntityId() },
                            method: "GET",
                            statusCode: {
                                200: function (data) {
                                    $("#corp-input-area").html(data);
                                }
                            }
                        });
                    } 

                    messageDialog("Success", "New product created");
                }
            });
        }
        else{

            // A) Standard model. Send the user back to the Setup tab after an Entity has been created

            $.ajax({
                url: Router.action("Portfolio", "CreateEntity", { area: "Corp" }),
                method: "POST",
                data: { name: name, CompanyId: GetCompanyId(), EntityId: GetEntityId() },
                success: function () {                

                    // Default call Statements tab...however, on the Statements HttpGet there is a check if shall get another tab, if e.g. CommodityExposureModel etc...
                    if(CurrentTab == "Setup"){
                        $.ajax({
                            url: Router.action("Tab", "Setup", { area: "Corp" }),
                            //url: Router.action("Tab", CurrentTabnewEntity, { area: "Corp" }),
                            data: { CompanyId: GetCompanyId(), EntityId: GetEntityId() },
                            method: "GET",
                            statusCode: {
                                200: function (data) {
                                    $("#corp-input-area").html(data);
                                }
                            }
                        });
                    }
                    else{
                        $.ajax({
                            url: Router.action("Tab", "Statements", { area: "Corp" }),
                            //url: Router.action("Tab", CurrentTabnewEntity, { area: "Corp" }),
                            data: { CompanyId: GetCompanyId(), EntityId: GetEntityId() },
                            method: "GET",
                            statusCode: {
                                200: function (data) {
                                    $("#corp-input-area").html(data);
                                }
                            }
                        });
                    }
                    //     messageDialog("New Entity created!", "For this entity:" + "<br />" + "- Keep the default generic setup, or select You can select Business type on the Setup tab" + "<br />" + "- Select Forecast input type on the Forecast tab. ");
                    // messageDialog("New Entity created!", "Keep the default/generic Business setup, or select another Business setup on the Setup tab");
                    messageDialog("New Entity created!", "");
                }
            });
        }
       

        if (typeof (callback) == "function") {
            callback();
        }
    });


}



export function SetEntityId(EntityId, tab) {
    var CompanyId = GetCompanyId();
    if (CompanyId == 0 && EntityId != 0) {
        messageDialog("No Company loaded");
        return;
    }
    var stateUrl = "/Corp/l" + "/" + GetCompanyId() + "/" + EntityId;
    if (tab != null && tab != "") {
        stateUrl = stateUrl + "/" + tab;
    }

    window.history.replaceState({ area: "Corp", CompanyId: GetCompanyId(), EntityId: EntityId, currenttab: tab }, null, stateUrl);

    $("#CurrentEntity").val(EntityId);
}

export function GetEntityId() {
    var SelectEntityIndex = $("#CurrentEntity").val();

    if (!$.isNumeric(SelectEntityIndex)) {
        SelectEntityIndex = 0;
    }
    return SelectEntityIndex;
}







